import React, { useEffect } from 'react';
import '../LegalPages.css';

function Terminos() {
  useEffect(() => {
    // Set page title
    document.title = 'Términos y Condiciones | Agencia La Botica';
    
    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex, nofollow';

    return () => {
      if (metaRobots) {
        metaRobots.content = 'index, follow';
      }
    };
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <a href="/" className="legal-logo">
            <img src="/logo-labotica.svg" alt="Agencia La Botica" />
          </a>
        </header>

        <main className="legal-content">
          <h1>Términos y Condiciones del Servicio</h1>
          <p className="legal-updated">Última actualización: Febrero 2026</p>

          <section>
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar el sitio web agencialabotica.cl (en adelante, "el Sitio"), 
              propiedad de <strong>Agencia de Publicidad La Botica Limitada</strong> ("La Botica", "nosotros"), 
              aceptas cumplir con estos Términos y Condiciones. Si no estás de acuerdo con alguna 
              parte de estos términos, te solicitamos no utilizar el Sitio.
            </p>
          </section>

          <section>
            <h2>2. Uso Aceptable del Sitio</h2>
            <p>Al utilizar nuestro Sitio, te comprometes a:</p>
            <ul>
              <li>Utilizar el Sitio únicamente para fines lícitos y de acuerdo con estos Términos.</li>
              <li>No intentar acceder a áreas restringidas del Sitio sin autorización.</li>
              <li>No introducir virus, malware o cualquier código malicioso.</li>
              <li>No realizar acciones que puedan dañar, sobrecargar o deteriorar el funcionamiento del Sitio.</li>
              <li>No utilizar el Sitio para enviar spam o comunicaciones no solicitadas.</li>
              <li>Proporcionar información veraz y actualizada cuando completes formularios de contacto.</li>
            </ul>
          </section>

          <section>
            <h2>3. Propiedad Intelectual</h2>
            <p>
              Todo el contenido del Sitio, incluyendo pero no limitado a textos, gráficos, logotipos, 
              imágenes, videos, diseños, código fuente y software, es propiedad de Agencia La Botica 
              o de sus respectivos licenciantes y está protegido por las leyes de propiedad intelectual 
              de Chile y tratados internacionales.
            </p>
            <p>
              Queda prohibida la reproducción, distribución, modificación, transmisión o uso de 
              cualquier contenido del Sitio sin la autorización previa y por escrito de La Botica, 
              excepto para uso personal y no comercial.
            </p>
          </section>

          <section>
            <h2>4. Servicios y Contenido</h2>
            <p>
              El Sitio proporciona información sobre los servicios de comunicación, branding, 
              neurociencia aplicada y producción audiovisual que ofrece La Botica. El contenido 
              del Sitio tiene carácter informativo y no constituye una oferta contractual vinculante 
              hasta que se formalice un acuerdo específico por escrito.
            </p>
            <p>
              Nos reservamos el derecho de modificar, actualizar o eliminar cualquier contenido 
              del Sitio en cualquier momento sin previo aviso.
            </p>
          </section>

          <section>
            <h2>5. Chatbot e Inteligencia Artificial</h2>
            <p>
              Nuestro Sitio incluye un chatbot impulsado por inteligencia artificial ("BoticarIA") 
              diseñado para proporcionar información general sobre nuestros servicios y facilitar 
              el contacto con nuestro equipo. Las respuestas del chatbot son orientativas y no 
              constituyen asesoramiento profesional vinculante. Para información precisa sobre 
              proyectos específicos, te recomendamos contactar directamente con nuestro equipo.
            </p>
          </section>

          <section>
            <h2>6. Enlaces a Terceros</h2>
            <p>
              El Sitio puede contener enlaces a sitios web de terceros, incluyendo pero no limitado a:
            </p>
            <ul>
              <li>Meta (Facebook e Instagram)</li>
              <li>LinkedIn</li>
              <li>Google</li>
              <li>YouTube</li>
              <li>Otras plataformas de redes sociales y servicios</li>
            </ul>
            <p>
              Estos enlaces se proporcionan únicamente para tu conveniencia. La Botica no controla 
              ni es responsable del contenido, políticas de privacidad o prácticas de sitios web 
              de terceros. Te recomendamos revisar los términos y políticas de cada sitio que visites.
            </p>
          </section>

          <section>
            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              En la máxima medida permitida por la ley chilena, La Botica no será responsable de:
            </p>
            <ul>
              <li>Daños directos, indirectos, incidentales, especiales o consecuentes derivados del uso o imposibilidad de uso del Sitio.</li>
              <li>Errores, inexactitudes u omisiones en el contenido del Sitio.</li>
              <li>Interrupciones, virus o fallos técnicos del Sitio.</li>
              <li>Acciones de terceros, incluyendo hackers o proveedores de servicios.</li>
              <li>Pérdida de datos, beneficios o interrupción del negocio.</li>
            </ul>
            <p>
              El Sitio se proporciona "tal cual" y "según disponibilidad", sin garantías de 
              ningún tipo, expresas o implícitas.
            </p>
          </section>

          <section>
            <h2>8. Indemnización</h2>
            <p>
              Aceptas indemnizar y mantener indemne a La Botica, sus directores, empleados y 
              colaboradores de cualquier reclamación, daño, pérdida o gasto (incluyendo honorarios 
              legales) derivados de tu uso del Sitio o violación de estos Términos.
            </p>
          </section>

          <section>
            <h2>9. Modificaciones a los Términos</h2>
            <p>
              Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier 
              momento. Los cambios entrarán en vigor inmediatamente después de su publicación 
              en el Sitio. El uso continuado del Sitio después de dichos cambios constituye 
              tu aceptación de los nuevos Términos.
            </p>
          </section>

          <section>
            <h2>10. Legislación Aplicable y Jurisdicción</h2>
            <p>
              Estos Términos y Condiciones se rigen por las leyes de la República de Chile. 
              Cualquier controversia derivada de estos Términos o del uso del Sitio será 
              sometida a la jurisdicción exclusiva de los tribunales ordinarios de justicia 
              de Santiago de Chile, renunciando expresamente a cualquier otro fuero que 
              pudiera corresponder.
            </p>
          </section>

          <section>
            <h2>11. Divisibilidad</h2>
            <p>
              Si alguna disposición de estos Términos se considera inválida o inaplicable, 
              las demás disposiciones permanecerán en pleno vigor y efecto.
            </p>
          </section>

          <section>
            <h2>12. Contacto</h2>
            <p>
              Si tienes preguntas sobre estos Términos y Condiciones, puedes contactarnos en:
            </p>
            <p>
              <strong>Agencia de Publicidad La Botica Limitada</strong><br />
              Santiago de Chile<br />
              Email: <a href="mailto:pablo@agencialabotica.cl">pablo@agencialabotica.cl</a>
            </p>
          </section>
        </main>

        <footer className="legal-footer">
          <p>© 2026 Agencia La Botica — Santiago, Chile</p>
        </footer>
      </div>
    </div>
  );
}

export default Terminos;
